<div class="row">
  <div class="col-12">
    <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
  </div>
  <div class="col-12">
    <a class="btn btn-primary rounded float-right"
       [title]="'PRESET_LIST.ADD_TOOLTIP' | translate"
       [routerLink]="['/presets/add']">
      <i class='fa fa-plus'></i>
    </a>

    <label class="btn btn-primary rounded float-right mr-3" [title]="'PRESET_LIST.IMPORT_TOOLTIP' | translate">
      <i class="fa fa-cloud-upload-alt" aria-hidden="true"></i>
      <input type="file" accept="application/json" hidden (change)="onFileChanged($event)">
    </label>

    <button class="btn btn-primary rounded float-right mr-3"
            [title]="'PRESET_LIST.EXPORT_TOOLTIP' | translate"
            (click)="exportPresets()"
            [disabled]="!hubAgenciesService.presets?.length">
      <i class="fa fa-download" aria-hidden="true"></i>
    </button>
  </div>
  <div class="col mt-5" *ngIf="hubAgenciesService.presets?.length">
    <div class="table-responsive">
      <table class="table table-default table-hover">
        <thead>
          <tr>
            <th>{{ 'PRESET_LIST.NAME' | translate }}</th>
            <th>{{ 'PRESET_LIST.AIRLINE' | translate }}</th>
            <th>{{ 'PRESET_LIST.PTCS' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
        <tr *ngFor="let preset of hubAgenciesService.presets | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; let idx = index;"
            class="cursor-pointer"
            (click)="$event.stopPropagation(); editPreset(idx)">
          <td>{{preset.title}}</td>
          <td>{{preset.airline}}</td>
          <td>
            <div class="d-flex justify-content-center gap-5">
              <div class="d-flex gap-5" *ngFor="let defaultTravelerType of defaultTravelerTypes; last as last">
                <ng-container *ngIf="defaultTravelerType">
                  <span style="width: 38px" [innerHTML]="defaultTravelerType | getPresetTravelerType: preset.travelers"></span>
                  <span>{{!last ? ' | ' : ''}}</span>
                </ng-container>
              </div>
            </div>
          </td>
          <td>
            <div class="d-flex gap-10">
              <div class="preset-img"
                   [ngbPopover]="mandatoryInfoPopover"
                   [class.active]="preset.isMandatory"
                   popoverClass="help-popover"
                   popoverTitle="{{ 'PRESET_LIST.MANDATORY_INFO_POPOVER.TITLE' | translate }}"
                   [triggers]="'hover'"
                   placement="top"
                   (click)="$event.stopPropagation(); updatePreset(preset, true)">M</div>
              <div class="preset-img"
                   [class.active]="preset.isDefault"
                   [ngbPopover]="defaultInfoPopover"
                   popoverClass="help-popover"
                   popoverTitle="{{ 'PRESET_LIST.DEFAULT_INFO_POPOVER.TITLE' | translate }}"
                   [triggers]="'hover'"
                   placement="top"
                   (click)="$event.stopPropagation(); updatePreset(preset, false)">D</div>
              <i class="material-symbols-outlined remove-icon"
                 [title]="'PRESET_LIST.REMOVE_TOOLTIP' | translate"
                 (click)="$event.stopPropagation(); deletePreset(idx)">
                delete
              </i>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <ngb-pagination *ngIf="hubAgenciesService.presets?.length > pageSize"
                    class="d-flex justify-content-end mt-4"
                    [collectionSize]="hubAgenciesService.presets.length"
                    [(page)]="page"
                    [pageSize]="pageSize"
                    [maxSize]="7"
                    [boundaryLinks]="true"
                    (pageChange)="onPageChange()"
    ></ngb-pagination>
  </div>
  <div class="col mt-5" *ngIf="!hubAgenciesService.presets?.length">
    {{ 'PRESET_LIST.NO_PRESETS' | translate }}
  </div>
</div>

<ng-template #defaultInfoPopover>
  <ul class="mb-0 pl-4">
    <li>{{ 'PRESET_LIST.DEFAULT_INFO_POPOVER.PRESELECTED' | translate }}</li>
    <li>{{ 'PRESET_LIST.DEFAULT_INFO_POPOVER.REMOVABLE' | translate }}</li>
  </ul>
</ng-template>

<ng-template #mandatoryInfoPopover>
  <ul class="mb-0 pl-4">
    <li>{{ 'PRESET_LIST.MANDATORY_INFO_POPOVER.PRESELECTED' | translate }}</li>
    <li>{{ 'PRESET_LIST.MANDATORY_INFO_POPOVER.NOT_REMOVABLE' | translate }}</li>
  </ul>
</ng-template>
